import type { AppConfig } from '#/config/types/AppConfig';
import type { SearchSortType } from '#/modules/search/types/SearchSortType';
import { isNotEmpty } from '#/utils/functional/poly';
import { invariant } from '#/utils/invariant';

type Args = {
  sort: SearchSortType;
  appConfig: AppConfig;
};

export function searchAlgoliaVolopsIndex({ sort, appConfig }: Args) {
  const { volopsIndexName } = appConfig.algolia;
  invariant(isNotEmpty(volopsIndexName), 'volopsIndexName cannot be empty');

  if (sort === 'relevance') return volopsIndexName;

  return `${volopsIndexName}-published-desc`;
}
